// @flow

import * as React from 'react'
import { connect } from 'react-redux'
import { getVisitor } from '../../redux/basic'

export default function (WrappedComponent: React.ComponentType<*>) {
  return connect(
    function (state) {
      return {
        visitor: getVisitor()
      }
    },
    null,
    null,
    { withRef: true }
  )(WrappedComponent)
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/hoc/visitorInfo.js